import React from "react";
import { formatRupiah } from "../helpers/validation";
import { RECIPIENT_TYPES } from "../constants/recipientTypes";

// Menampilkan hasil simulasi dari backend (source of truth). Tidak menghitung
// apa pun sendiri — hanya merender angka yang dikirim endpoint.
const AllocationSummary = ({ result, loading }) => {
  if (loading) {
    return (
      <div style={{ textAlign: "center", color: "#999", padding: "40px 0", fontSize: "14px" }}>
        Calculating…
      </div>
    );
  }
  if (!result) {
    return (
      <div style={{ textAlign: "center", color: "#bbb", padding: "40px 0", fontSize: "14px" }}>
        Adjust recipients to see the allocation summary.
      </div>
    );
  }

  const row = { display: "flex", justifyContent: "space-between", alignItems: "baseline", padding: "10px 0", borderBottom: "1px solid #f0f0f0" };
  const labelBold = { fontSize: "14px", fontWeight: 700, color: "#231f20" };
  const amountBold = { fontSize: "14px", fontWeight: 700, color: "#231f20" };

  return (
    <div>
      {/* Header numbers */}
      <div style={{ display: "flex", justifyContent: "space-between", padding: "8px 0 14px" }}>
        <div>
          <div style={{ fontSize: "12px", color: "#888" }}>Registration Price</div>
          <div style={{ fontSize: "22px", fontWeight: 800, color: "#231f20" }}>
            {formatRupiah(result.registrationPrice)}
          </div>
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={{ fontSize: "12px", color: "#888" }}>Discount (CEA covers)</div>
          <div style={{ fontSize: "22px", fontWeight: 800, color: "#fb3104" }}>
            {result.discountPercent}%
          </div>
        </div>
      </div>

      {/* Recipients */}
      <div style={{ marginTop: "6px" }}>
        {result.recipients.map((r, i) => (
          <div key={i}>
            <div style={row}>
              <span style={labelBold}>
                {r.type}
                <span style={{ fontWeight: 500, color: "#999", marginLeft: "8px", fontSize: "13px" }}>
                  {r.percent}%
                </span>
                {r.email && (
                  <span style={{ fontWeight: 400, color: "#aaa", marginLeft: "6px", fontSize: "12px" }}>
                    · {r.email}
                  </span>
                )}
              </span>
              <span style={amountBold}>{formatRupiah(r.amount)}</span>
            </div>

            {/* Student breakdown — tiap student nominal penuh */}
            {r.type === RECIPIENT_TYPES.STUDENT && Array.isArray(r.students) && (
              <div style={{ padding: "4px 0 8px 16px" }}>
                {r.students.map((s, j) => (
                  <div key={j} style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", fontSize: "13px", color: "#555" }}>
                    <span>{s.name || `Student ${j + 1}`}</span>
                    <span>{formatRupiah(s.amount)}</span>
                  </div>
                ))}
              </div>
            )}

            {/* Installment schedule */}
            {r.installment && (
              <div style={{ margin: "6px 0 10px 16px", padding: "10px 12px", background: "#fafafa", borderRadius: "8px", border: "1px solid #eee" }}>
                <div style={{ display: "flex", justifyContent: "space-between", fontSize: "12.5px", fontWeight: 600, color: "#444" }}>
                  <span>Due now</span>
                  <span>{formatRupiah(r.installment.dpAmount)}</span>
                </div>
                {r.installment.schedule.map((st, k) => (
                  <div key={k} style={{ marginTop: "8px" }}>
                    <div style={{ fontSize: "11.5px", fontWeight: 700, color: "#999", textTransform: "uppercase", letterSpacing: "0.4px" }}>
                      {st.studentName}
                    </div>
                    {st.rows.map((row2, m) => (
                      <div key={m} style={{ display: "flex", justifyContent: "space-between", fontSize: "12px", color: "#666", padding: "2px 0" }}>
                        <span>
                          {row2.label}
                          {row2.note && <span style={{ color: "#aaa" }}> · {row2.note}</span>}
                        </span>
                        <span>{row2.amount == null ? "—" : formatRupiah(row2.amount)}</span>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Total */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "14px", padding: "12px 0 0", borderTop: "2px solid #231f20" }}>
        <span style={{ fontSize: "15px", fontWeight: 800, color: "#231f20" }}>
          Total Allocation
          <span style={{ marginLeft: "10px", fontSize: "13px", fontWeight: 700, color: result.valid ? "#16a34a" : "#c0392b" }}>
            {result.totalPercent}%
          </span>
        </span>
        <span style={{ fontSize: "15px", fontWeight: 800, color: "#231f20" }}>
          {formatRupiah(result.totalAllocated)}
        </span>
      </div>
    </div>
  );
};

export default AllocationSummary;
